import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
import { colors } from '../../../../utils/styles/defaultTheme';
const LockIndicator = /*#__PURE__*/React.memo(props => {
  let icon = /*#__PURE__*/React.createElement(Icon, {
    name: "lockOutline",
    size: "medium",
    color: colors.grey[500]
  });
  if (props?.selectProps?.lockIcon) {
    icon = props?.selectProps?.lockIcon;
  }
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, icon);
});
LockIndicator.displayName = 'LockIndicator';
export default LockIndicator;